var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShareIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4358_12150)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 5.83325C13.1046 5.83325 14 4.93782 14 3.83325C14 2.72868 13.1046 1.83325 12 1.83325C10.8954 1.83325 10 2.72868 10 3.83325C10 4.93782 10.8954 5.83325 12 5.83325Z",
    stroke: "#134A70",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 10.5C5.10457 10.5 6 9.60457 6 8.5C6 7.39543 5.10457 6.5 4 6.5C2.89543 6.5 2 7.39543 2 8.5C2 9.60457 2.89543 10.5 4 10.5Z",
    stroke: "#134A70",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 15.1667C13.1046 15.1667 14 14.2713 14 13.1667C14 12.0622 13.1046 11.1667 12 11.1667C10.8954 11.1667 10 12.0622 10 13.1667C10 14.2713 10.8954 15.1667 12 15.1667Z",
    stroke: "#134A70",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.72665 9.50659L10.28 12.1599",
    stroke: "#134A70",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2733 4.84009L5.72665 7.49342",
    stroke: "#134A70",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4358_12150"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareIcon);
export default __webpack_public_path__ + "static/media/share_icon.9ee02c4e6bb59c1ffc74d9c9354852b4.svg";
export { ForwardRef as ReactComponent };